import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import ToolbarTool from '../../../ToolbarTool';
import useSheet from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../../../../../mobile/structural/sheet/sheetTypes';
import ColorToolIcon from '../../colorTools/ColorToolIcon';
import { getActiveToolbarLabel } from '../../../../../../element/labels/labelSelectors';
import { getColorDisplayValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import { Sheet } from '../../../../../../mobile/structural/sheet/Sheet';
import LabelColorPicker from '../components/LabelColorPicker';

import { useLabelColorSheetHandler } from '../hooks/useLabelColorSheetHandler';
import CustomColorInput from '../../colorTools/CustomColorInput';

type MobileLabelColorToolProps = {
    name: string;
};

const MobileLabelColorTool = ({ name }: MobileLabelColorToolProps): ReactElement | null => {
    const sheetProps = useSheet(SheetId.LabelColorTool);
    const selectedLabel = useSelector(getActiveToolbarLabel);

    const {
        selectedColor,
        selectedColorHex,
        showCustomColorInput,
        customColorInputRef,
        handleTempColorChange,
        handleColorChange,
        openCustomColorPicker,
        onCustomColorInputFocus,
        onCustomColorInputBlur,
    } = useLabelColorSheetHandler(selectedLabel, sheetProps);

    if (!selectedLabel) return null;

    return (
        <>
            <ToolbarTool name={name} isOpen={sheetProps.isOpen} onClick={() => sheetProps.openSheet()}>
                <ColorToolIcon
                    key={`label-color-${selectedLabel._id}`}
                    supportColorBar={false}
                    supportBackgroundColor={false}
                    selectedType={undefined}
                    color={getColorDisplayValue(selectedLabel.color)}
                    isActive={sheetProps.isOpen}
                />
            </ToolbarTool>
            <>
                <Sheet className="LabelColorSheet color-tool" {...sheetProps}>
                    <Sheet.Overlay />
                    <Sheet.Panel>
                        <Sheet.Content className="px-3xl py-3xl mb-3xl">
                            <LabelColorPicker
                                selectedColor={selectedColor ? selectedColor : null}
                                selectedColorHex={selectedColorHex}
                                openCustomColorPicker={openCustomColorPicker}
                                handleColorChange={handleColorChange}
                            />
                        </Sheet.Content>
                    </Sheet.Panel>
                </Sheet>

                {showCustomColorInput && (
                    <CustomColorInput
                        className="custom-color-picker-input absolute top-0 left-0 opacity-0 pointer-events-none"
                        ref={customColorInputRef}
                        initialColor={selectedColorHex}
                        setTempColor={handleTempColorChange}
                        setColor={handleColorChange}
                        onFocus={onCustomColorInputFocus}
                        onBlur={onCustomColorInputBlur}
                    />
                )}
            </>
        </>
    );
};

export default MobileLabelColorTool;
